import $ from 'jquery';

import Component from '../Component';

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class VerificationPopup extends Component {

  constructor(theme, element) {
    super(theme, element);

    this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10);
    this.ageDelay = 0;
    this.ageTestMode = this.element.dataset.ageTestMode === 'true';
    this.enterButton = element.querySelector('#button__enter');
    this.exitButton = element.querySelector('#button__exit');
    this.returnButton = element.querySelector('#button__return');
    this.closeButton = element.querySelector('.verification-popup__close-button');
    this.modalLinks = element.querySelector('.modal-content__wrapper a');

    this.load();
  }

  load = () => {

    // Age checker is in test mode - will show immediately in editor and on live site
    if(this.ageTestMode) this.showModal();

    if(this.modalLinks) {
      this.modalLinks.setAttribute('tabindex', '1');
    }

    var isAnAdult = this.readCookie('isAnAdult');
    if (!isAnAdult) {
      if (window.Shopify.designMode && !this.ageTestMode) return;
      this.showModal();
    }

    if(this.enterButton) {
      this.enterButton.addEventListener('click', this.writeCookie);
    }

    if(this.exitButton) {
      this.exitButton.addEventListener('click', this.comeBackModal);
    }

    if(this.returnButton) {
      this.returnButton.addEventListener('click', this.confirmAgeModal);
    }

    if(this.closeButton) {
      this.closeButton.addEventListener('click', this.confirmAgeModal);
    }
  }

  writeCookie = () => {
    // document.write("<style> #prompt__background { display: none; }</style>");
    document.cookie = "isAnAdult=true; expires=0; path=/";
    this.hideModal();
  }

  getModalContent = () => {
    this.changeContent = document.querySelector('.modal-deny-content');
    this.hideInitial = document.querySelector('.modal-initial-content');
  }

  trapFocus = () => {
    setTimeout(() => {
      if(document.querySelector('.verification-popup-container')) {
        var inputs = $('.verification-popup-container').find('button, a').filter(':visible');
        var firstInput = inputs.first();
        var lastInput = inputs.last();

        // Set focus on first input
        $('.verification-popup-container').focus();

        // Redirect last tab to first input
        lastInput.on('keydown', function (e) {
          if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault();
            firstInput.focus();
          }
        });

        // Redirect first shift+tab to last input
        firstInput.on('keydown', function (e) {
          if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault();
            lastInput.focus();
          }
        });
      }
    }, 250);
  }

  readCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0 ; i < ca.length ; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  showModal = () => {
    $('.verification-popup-container').css('display', 'block');
    this.trapFocus();
    disableBodyScroll(document.querySelector('.verification-popup-container'));
  }

  hideModal = () => {
    enableBodyScroll(document.querySelector('.verification-popup-container'));
    $('.verification-popup-container').css('display', 'none');
  }

  confirmAgeModal = () => {
    $('#verification__prompt').scrollTop(0);
    $('.verification-popup__close-button').css('display', 'none');
    this.getModalContent();
    this.changeContent.classList.add('hidden');
    this.hideInitial.classList.remove('hidden');
    this.trapFocus();
  }

  comeBackModal = () => {
    $('#verification__prompt').scrollTop(0);
    $('.verification-popup__close-button').css('display', 'flex');
    this.getModalContent();
    this.changeContent.classList.remove('hidden');
    this.hideInitial.classList.add('hidden');
    this.trapFocus();
  }
}
